@if (showGoBack) {
  <bdeo-link
    class="left"
    data-test-id="back-button"
    size="large"
    target="_blank"
    color="var(--default)"
    icon="arrow-angle-left"
    (click)="goBack()"
  >
    {{ 'list' | i18nextEager }}</bdeo-link
  >
  @if (showSecondaryActions) {
    <bdeo-button
      class="right"
      type="basic"
      icon="action-more"
      (click)="openSecondaryActions()"
      [disabled]="actionsDisabled$ | async"
    ></bdeo-button>
  }
} @else {
  @if (!loading) {
    @if (customLogo) {
      <img [src]="customLogo" alt="company logo" (click)="goToHome()" />
    } @else if (defaultLogo) {
      <bdeo-logo height="24px" name="logo-positivo" (click)="goToHome()"></bdeo-logo>
    }
  } @else {
    <bdeo-skeleton-thumbnail size="small"></bdeo-skeleton-thumbnail>
  }
  <bdeo-icon class="right" color="var(--default)" name="action-off" (click)="openLogOutDialog()"></bdeo-icon>
}
